import React, { Component } from 'react';
import Header from "../layout/header"
// import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import Footer from "../layout/footer"
import Menu from "../layout/doctorLeftmenu"
import { Link } from "react-router-dom";
import editImg from "../images/edit.png"
import "../css/adminStyle.css"
import deleteImg from "../images/delete.png"
import { database } from '../firebase'

export default class Stories extends Component {
    constructor(props) {
        super(props)
        this.state = {
            storyData: [],
        }
    }
    componentDidMount(){
        this.renderList();
    }
    async  renderList(){
        let dataList=[]
        await database.ref("stories").once('value',function(snapshot){
            snapshot.forEach(
             function(ChildSnapshot){
                 
                dataList.push({
                    key:ChildSnapshot.key,
                    storyTitle:ChildSnapshot.val().title,
                    storyImage :ChildSnapshot.val().imageUrl,
                    storyStatus:ChildSnapshot.val().status,
                    storyDescription:ChildSnapshot.val().description,
                    storyCategory:ChildSnapshot.val().category,
                    mainCategory:ChildSnapshot.val().mainCategory
                })
                //console.log("dataList...",dataList)
             }
            )
        })
        this.setState({
            storyData:dataList
        })
    }

    render() {
        const html = '<div>Example HTML string</div>';
        return (
            <div className="main-wrapper">
                <Header></Header>
                <div className="main-content">
                    <Menu></Menu>
                    <div className="content-right-wrapper">
                        <div className="container">
                            <div className='form-wrapper'>
                                <ul className="breadcrumb">
                                    <li><a href="/dashboard">Dashboard</a></li>
                                    <li>Stories</li>
                                </ul>
                                <div className='form-head'>
                                    Stories
                                    <Link to="/newStories/keyId=0"><button className='addNewBtn btn'> New Stories</button></Link>
                                </div>
                                <div className='table'>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th scope="col">ID</th>
                                                <th scope="col">Title</th>
                                                {/* <th scope="col">Description</th> */}
                                                <th scope="col">Main Category</th>
                                                <th scope="col">Category</th>
                                                <th scope="col">Banner</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.storyData.map((data, i) => {
                                            return (
                                                <tr>
                                                <th scope="row">{i + 1}</th>
                                                <td>{data.storyTitle}</td>
                                                {/* { ReactHtmlParser(data.storyDescription) } */}
                                                <td>{data.mainCategory}</td>
                                                <td>{data.storyCategory}</td>
                                                <img src={data.storyImage} style={{width:"100px",height:"100px"}} className='actionIcon' ></img>
                                                <td>{data.storyStatus}</td>
                                                <td>
                                                    <Link to={'/newstories/keyId=' + data.key} params={data.key}>
                                                        <img src={editImg} className='actionIcon' ></img>
                                                    </Link>
                                                    {/* <img src={deleteImg} className='actionIcon' onClick={() => this.deleteData(data.key)}></img> */}
                                                </td>
                                            </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                                {/* <div>
                                    <nav aria-label="Page navigation example">
                                        <ul className="pagination justify-content-end">
                                            <li className="page-item">
                                                <a className="page-link" href="#" aria-label="Previous">
                                                    <span aria-hidden="true">&laquo;</span>
                                                    <span className="sr-only">Previous</span>
                                                </a>
                                            </li>
                                            <li className="page-item"><a className="page-link" href="#">1</a></li>
                                            <li className="page-item"><a className="page-link" href="#">2</a></li>
                                            <li className="page-item"><a className="page-link" href="#">3</a></li>
                                            <li className="page-item">
                                                <a className="page-link" href="#" aria-label="Next">
                                                    <span aria-hidden="true">&raquo;</span>
                                                    <span className="sr-only">Next</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer></Footer>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/admin/stories.jsx